import { render, staticRenderFns } from "./SelecionarContaDialog.vue?vue&type=template&id=2304162f&"
import script from "./SelecionarContaDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarContaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports